/// <reference types="vite/client" />
import React from 'react';
import ReactDOM from 'react-dom/client';
// Explicitly import ensure-react before any other imports to guarantee React is loaded first
import './lib/ensure-react';
import App from './App';

// Import analytics and web vitals
// import './analytics/datadog'; // Initialize Datadog RUM
// import { reportWebVitals, reportWebVitalsToDatadog } from './analytics/webVitals';

import './styles/global.css';
import './styles/table-vertical-lines.css';
import { BrowserRouter } from 'react-router-dom';

// Make React available on window for troubleshooting external libraries that expect it
if (import.meta.env.DEV) {
  window.React = React;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <App/>
  </BrowserRouter>);

// Report web vitals using the Datadog reporter
// reportWebVitals(reportWebVitalsToDatadog);